/**
 * モーダル（lightbox）プレイヤー
 *
 * モーダル要素を document.body 直下へ移動することで
 * 親要素の overflow/transform/position などの影響を受けずに
 * 画面全体に表示させる。
 */

export function setupModal( block, config ) {
	const blockId = config.blockId;
	const modal   = document.getElementById( `${ blockId }-modal` );
	if ( ! modal ) return;

	// body 直下へ移動（親要素の stacking context の影響を排除）
	document.body.appendChild( modal );

	const playerWrap = modal.querySelector( '.sab-yt-modal-player' );
	const closeBtn   = modal.querySelector( '.sab-yt-modal-close' );
	const backdrop   = modal.querySelector( '.sab-yt-modal-backdrop' );
	const log        = config.log;

	// カードクリック
	block.addEventListener( 'click', ( e ) => {
		const link = e.target.closest( '.sab-yt-card__thumb-link[data-play-mode="modal"]' );
		if ( ! link ) return;
		e.preventDefault();

		const card    = link.closest( '.sab-yt-card' );
		const videoId = card?.dataset.videoId;
		if ( ! videoId ) return;

		log( `MODAL open videoId=${ videoId }` );
		openModal( modal, playerWrap, videoId );
	} );

	// 閉じるボタン
	closeBtn?.addEventListener( 'click', () => { log( 'MODAL close (button)' ); closeModal( modal, playerWrap ); } );
	backdrop?.addEventListener( 'click', () => { log( 'MODAL close (backdrop)' ); closeModal( modal, playerWrap ); } );

	// ESC キー
	document.addEventListener( 'keydown', ( e ) => {
		if ( e.key === 'Escape' && ! modal.hidden ) {
			log( 'MODAL close (ESC)' );
			closeModal( modal, playerWrap );
		}
	} );
}

function openModal( modal, playerWrap, videoId ) {
	playerWrap.innerHTML = `
		<iframe
			src="https://www.youtube-nocookie.com/embed/${ encodeURIComponent( videoId ) }?autoplay=1&rel=0"
			title="YouTube video player"
			frameborder="0"
			allow="autoplay; encrypted-media; picture-in-picture"
			allowfullscreen
		></iframe>
	`;
	modal.hidden = false;
	document.body.classList.add( 'sab-yt-modal-open' );
	modal.querySelector( '.sab-yt-modal-close' )?.focus();
}

function closeModal( modal, playerWrap ) {
	modal.hidden = true;
	playerWrap.innerHTML = '';
	document.body.classList.remove( 'sab-yt-modal-open' );
}